// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2aPGW","header":"ClearentDisclaimer_header__3klVJ","inner":"ClearentDisclaimer_inner__2bj8R"};